import { userStorage } from '@/hooks/useStorage';

const { getStorage, removeStorage } = userStorage();

// 延迟到达的旧请求不能清除用户刚刚重新登录的凭证。
export const expireSession = (token, message = '登录已失效，请重新登录') => {
	if (!token || getStorage('token') !== token) return;
	removeStorage('token');
	removeStorage('userInfo');
	uni.showToast({ title: message, icon: 'none', duration: 1500 });
	uni.reLaunch({ url: '/pages/login/login' });
};
